import { get } from 'lodash';

const MAX_RETRIES = 12;
const RETRY_DELAY = 1000;

const waitAndDecrement = async (delay: number, attemptsLeft: number): Promise<number> => {
    await new Promise((resolve) => setTimeout(resolve, delay));

    return attemptsLeft - 1;
};

export const isSectionEmpty = (response, sectionName) => !get(response.data, `sections.${sectionName}`);

export const retryAsync = async (fn, { retries = MAX_RETRIES, delay = RETRY_DELAY, sectionName = null } = {}) => {
    let attemptsLeft = retries;

    while (attemptsLeft >= 0) {
        try {
            const result = await fn();

            if (!isSectionEmpty(result, sectionName)) {
                return result;
            }

            if (attemptsLeft <= 0) {
                return result;
            }

            attemptsLeft = await waitAndDecrement(delay, attemptsLeft);
        } catch (err) {
            if (attemptsLeft <= 0) {
                throw err;
            }

            attemptsLeft = await waitAndDecrement(delay, attemptsLeft);
        }
    }
};
